import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import NumberDisplay from 'src/javascripts/components/utilities/NumberDisplay';
import Swal from 'sweetalert2';
import DisableUnchangedFields from 'src/javascripts/components/surveys/functions/DisableUnchangedFields';
import EnableUnchangedFields from 'src/javascripts/components/surveys/functions/EnableUnchangedFields';
import GridNav from 'src/javascripts/components/surveys/GridNav';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Idle tracking + auto-save cadence constants
const SURVEY_ACTIVITY_EVENTS = ['mousemove', 'keydown', 'scroll', 'mousedown', 'touchstart'];
const IDLE_TIMEOUT_MS = 60_000; // 1 minute in milliseconds
const POLL_INTERVAL_MS = 7_000; // 7 seconds in milliseconds
const ACTIVITY_THROTTLE_MS = 1_000; // Throttle updates to once per second

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class SurveysShow {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

		// Navigating around the questionnaire grid layout
		GridNav();

    // Full submission flow prompts for confirmation and then posts the form
    $('#submitSurvey').click(function(el) {
      el.preventDefault();

      // Confirm and then continue
      return Swal.fire({
        title: "Confirm submission",
        text: "Please confirm that you would like to finalize and submit the survey. If you need others on your account to approve the survey, you can specify them in the next step.",
        animation: false,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-light border',
          popup: 'animated fadeIn faster'
        }
      }).then((result) => {
        if (result.value) {
          // Add field to form to indicate we're submitting it
          $('#hidden_status').val("submitted");

          // Opacity on page
          $('#save_survey_form .data-collection-content').css('opacity', 0.25)
          $('.submit-survey-spinner-container').removeClass('d-none');
          Spinner($('.submit-survey-spinner-container'));

          // Remove non-changed fields
          DisableUnchangedFields();

          // Submit form
          $('#hiddenSaveSurvey').click();

        }
      });

    })

    // Roll a submitted survey back to Active status
    $('.unsubmit-survey').click(function(el) {
      el.preventDefault();

      // Confirm and then continue
      return Swal.fire({
        title: "Confirm",
        text: "Please confirm that you would like to change the status of this survey back to 'Active'.",
        animation: false,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-light border',
          popup: 'animated fadeIn faster'
        }
      }).then((result) => {
        if (result.value) {
          
          // Add field to form to indicate we're submitting it
          $('#hidden_status').val("active");

          // Opacity on page
          $('#save_survey_form .data-collection-content').css('opacity', 0.25)
          $('.submit-survey-spinner-container').removeClass('d-none');
          Spinner($('.submit-survey-spinner-container'));

          // Remove non-changed fields
          DisableUnchangedFields();

          // Submit form - first need to enable fields, otherwise rails UJS doesn't submit form
          $('input, select, textarea').attr('disabled', false);
          $('#hiddenSaveSurvey').click();

        }
      });

    })

    // Manual save button performs a synchronous PATCH and pauses auto-save
    $('#saveSurvey').on('click', function(el) {
      el.preventDefault();

      // Pause auto-save so we don't fire overlapping PATCHes while this manual request runs
      SurveysShow.manualSaveInFlight = true;
      SurveysShow.pollActive = false;

      // Check if any values changed      
      let valChanged = $('.survey-card-body[data-val-changed=\'true\']');

      // Opacity on page
      $('#pollingSpinner').removeClass('d-none');

      // Remove non-changed fields
      DisableUnchangedFields();

      // Submit form
      $('#hiddenSaveSurvey').click();

      // Change fields back to enabled
      EnableUnchangedFields();    

    });

    const resetChangedFlags = () => {
      $('.survey-card-body[data-val-changed="true"]').attr('data-val-changed', 'false');
    };

    const $pollingIndicator = $('.polling-indicator');
    if ($pollingIndicator.length === 0 || $('#save_survey_form').length === 0) {
      return; // No polling indicator or save_survey_form present, skip auto-save wiring
    }

    // Track polling state once per browser session
    if (typeof SurveysShow.lastActivityTime === 'undefined') {
      SurveysShow.lastActivityTime = Date.now();
    }
    if (typeof SurveysShow.pollActive === 'undefined') {
      SurveysShow.pollActive = false;
    }
    if (typeof SurveysShow.pollId === 'undefined') {
      SurveysShow.pollId = null;
    }
    if (typeof SurveysShow.pollTimeoutId === 'undefined') {
      SurveysShow.pollTimeoutId = null;
    }
    if (typeof SurveysShow.manualSaveInFlight === 'undefined') {
      SurveysShow.manualSaveInFlight = false;
    }
    if (typeof SurveysShow.lastActivityRefreshAt === 'undefined') {
      SurveysShow.lastActivityRefreshAt = 0;
    }
    // Timed auto-save poller
    const timedSavePoll = (pollId) => {
      if (SurveysShow.manualSaveInFlight) {
        return; // manual submission is running; skip auto-save
      }

      const lapsedTime = Date.now() - SurveysShow.lastActivityTime;
      if (lapsedTime >= IDLE_TIMEOUT_MS) {
        SurveysShow.pollActive = false;
        return; // User is idle, do not run poll
      }

      const savingPoll = $pollingIndicator.attr('data-saving-poll');
      if (savingPoll !== pollId) {
        return; // Another poll has been scheduled since this one was created
      }

      SurveysShow.pollActive = true;
      const surveySlug = $pollingIndicator.attr('data-slug');
      const url = `/${accountUrl}/surveys/${surveySlug}/save?`;

      $.ajax({
        type: 'PATCH',
        dataType: 'application/json',
        data: $('#save_survey_form').serialize(),
        timeout: 10000,
        url,
        success: resetChangedFlags,
        complete() {
          if (!SurveysShow.pollActive || $('#save_survey_form').length === 0) {
            return;
          }
          const activePoll = $pollingIndicator.attr('data-saving-poll');
          if (!activePoll || activePoll !== pollId) {
            return;
          }
          SurveysShow.pollTimeoutId = setTimeout(() => timedSavePoll(pollId), POLL_INTERVAL_MS);
          const questionGroupId = $pollingIndicator.attr('data-question-group-id');
          const pollParams = {};
          if (typeof questionGroupId !== 'undefined') {
            pollParams['question_group_id'] = questionGroupId;
          }
          const pollUrl = `/${accountUrl}/surveys/${surveySlug}/poll.js?${$.param(pollParams)}`;
          $pollingIndicator.find('.spinner-border').removeClass('d-none');
          $.ajax({
            type: 'POST',
            dataType: 'script',
            timeout: POLL_INTERVAL_MS,
            url: pollUrl
          });
        }
      });
    };

    const ensurePollingScheduled = () => {
      const surveyStatus = $pollingIndicator.attr('data-status');
      // If a poll is already active, or the survey is finalized (approved/submitted),
      // do not schedule a new poll. When pollActive is false and the survey is not
      // finalized, this function will (re)start polling.
      if (SurveysShow.pollActive || surveyStatus === 'approved' || surveyStatus === 'submitted') {
        return;
      }

      // Avoid scheduling if the user has been idle longer than the allowed window.
      const idleDuration = Date.now() - SurveysShow.lastActivityTime;
      if (idleDuration >= IDLE_TIMEOUT_MS) {
        return;
      }

      SurveysShow.pollId = (1 + Math.floor(Math.random() * 1000000)).toString();
      $pollingIndicator.attr('data-saving-poll', SurveysShow.pollId);
      SurveysShow.pollActive = true;
      SurveysShow.pollTimeoutId = setTimeout(() => timedSavePoll(SurveysShow.pollId), POLL_INTERVAL_MS);
    };

    const stopPolling = () => {
      SurveysShow.pollActive = false;
      SurveysShow.pollId = null;
      $pollingIndicator.removeAttr('data-saving-poll');
      if (SurveysShow.pollTimeoutId) {
        clearTimeout(SurveysShow.pollTimeoutId);
        SurveysShow.pollTimeoutId = null;
      }
    };

    const clearManualSaveInFlight = () => {
      SurveysShow.manualSaveInFlight = false;
      ensurePollingScheduled();
    };

    const removeActivityListeners = () => {
      if (!SurveysShow.handleActivityEvent) {
        return;
      }

      SURVEY_ACTIVITY_EVENTS.forEach(event => {
        document.removeEventListener(event, SurveysShow.handleActivityEvent, false);
      });
    };

    removeActivityListeners();

    // Throttled activity handler updates idle clock + polling
    SurveysShow.handleActivityEvent = () => {
      const now = Date.now();
      if (now - SurveysShow.lastActivityRefreshAt < ACTIVITY_THROTTLE_MS) {
        return;
      }

      SurveysShow.lastActivityRefreshAt = now;
      SurveysShow.lastActivityTime = now;
      ensurePollingScheduled();
    };

    SURVEY_ACTIVITY_EVENTS.forEach(event => {
      document.addEventListener(event, SurveysShow.handleActivityEvent, false);
    });

    if (SurveysShow.handleTurboBeforeCache) {
      document.removeEventListener('turbo:before-cache', SurveysShow.handleTurboBeforeCache);
    }

    SurveysShow.handleTurboBeforeCache = () => {
      removeActivityListeners();
      stopPolling();
    };

    document.addEventListener('turbo:before-cache', SurveysShow.handleTurboBeforeCache);

    if (SurveysShow.handleTurboBeforeVisit) {
      document.removeEventListener('turbo:before-visit', SurveysShow.handleTurboBeforeVisit);
    }

    SurveysShow.handleTurboBeforeVisit = () => {
      removeActivityListeners();
      stopPolling();
    };

    document.addEventListener('turbo:before-visit', SurveysShow.handleTurboBeforeVisit);

    // Rails UJS callbacks resume auto-save once the manual form POST finishes
    $('#save_survey_form')
      .off('.surveysAutoSave')
      .on('ajax:complete.surveysAutoSave', clearManualSaveInFlight)
      .on('ajax:success.surveysAutoSave', () => resetChangedFlags());

    if (SurveysShow.handleTurboSubmitEnd) {
      document.removeEventListener('turbo:submit-end', SurveysShow.handleTurboSubmitEnd);
    }

    // Turbo form submissions finish here; restart auto-save loop afterwards
    SurveysShow.handleTurboSubmitEnd = (event) => {
      if (event.target && event.target.id === 'save_survey_form') {
        if (event.detail && event.detail.success) {
          resetChangedFlags();
        }
        clearManualSaveInFlight();
      }
    };

    document.addEventListener('turbo:submit-end', SurveysShow.handleTurboSubmitEnd);

    ensurePollingScheduled();

    // Fire an immediate poll on page load to sync the progress bar with the real
    // server state without waiting for user interaction.  The server-rendered
    // data-server-percent comes from a background-job tracking record that may be
    // stale (e.g. answers were cleared but the tracking hasn't been recalculated
    // yet), so this corrects the bar within milliseconds of load.
    const surveySlugForImmediatePoll = $pollingIndicator.attr('data-slug');
    const surveyStatusForImmediatePoll = $pollingIndicator.attr('data-status');
    const shouldPollForImmediatePoll = $pollingIndicator.attr('data-should-poll');
    const questionGroupIdForImmediatePoll = $pollingIndicator.attr('data-question-group-id');
    const shouldRunImmediatePoll = shouldPollForImmediatePoll === 'true'
      ? true
      : surveyStatusForImmediatePoll !== 'approved' && surveyStatusForImmediatePoll !== 'submitted';

    if (surveySlugForImmediatePoll && shouldRunImmediatePoll) {
      const immediatePollData = {};
      if (questionGroupIdForImmediatePoll) {
        immediatePollData.question_group_id = questionGroupIdForImmediatePoll;
      }
      $.ajax({
        type: 'POST',
        dataType: 'script',
        timeout: POLL_INTERVAL_MS,
        url: `/${accountUrl}/surveys/${surveySlugForImmediatePoll}/poll.js`,
        data: immediatePollData
      });
    }

    // Lazy-load custom framework ratings if present on page
    if ( $('#customFrameworkRatingsList').length !== 0 ) {
      let issuerId = $('#customFrameworkRatingsList').attr('data-issuer-id');
      let frameworkId = $('#customFrameworkRatingsList').attr('data-framework-id');
      let surveySlug = $('#customFrameworkRatingsList').attr('data-survey-slug');
      let url = "/issuers/" + issuerId + "/ratings/custom_framework_scorecard";
      let params = {};
      if (frameworkId) { params['framework_id'] = frameworkId; }
      if (surveySlug) { params['survey_slug'] = surveySlug; }
      Spinner($('#customFrameworkRatingsList'));
      $.ajax({
        type: "GET",
        dataType: "script",
        url: url + '?' + $.param(params)
      });
    }

  }

}
